import axios from 'axios';
// import { HttpStatusCodes } from '../constants/http-status-codes.enum';
// import { CheckoutBillingInfo } from '../components/e-commerce/checkout';

// ----------------------------------------------------------------------

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use((config) => {
  if (config.url === 'export/export') {
    config.url = 'http://192.168.1.9:8099/api/export/export';
  } else {
    config.url = `${process.env.REACT_APP_MAIN_URL_BACKEND}${config.url}`;
  }
  config.headers.common = {
    'accept-language': localStorage.getItem('i18nextLng') || 'tr',
    'x-access-token': localStorage.getItem('accessToken') || null,
    'Content-Type': ' multipart/form-data',
    ...config.headers.common
  };
  return config;
});

/* axiosInstance.interceptors.response.use((response) => {
  /* HATA: if (response.status != HttpStatusCodes.StatusSuccess) {
    throw response.data;
  }  * /
  if (
    response.status == HttpStatusCodes.StatusSuccess ||
    response.status == HttpStatusCodes.StatusCreated
  ) {
    return response.data;
  }
  throw response.data;
}); */

axiosInstance.interceptors.response.use(
  (response) => {
    console.log('response');
    return response;
  },
  (error) => {
    console.log('error...', error);
    return Promise.reject(
      (error.response && error.response.data) || 'Something went wrong'
    );
  }
);

export default axiosInstance;
